import React from 'react'
import { Box, Box as CardContainer } from '@node-space/storybook-components/dist/Box'
import { Button, ButtonProps } from '@node-space/storybook-components/dist/Button'
import Icon from '@node-space/storybook-components/dist/Icon'
import Text from '@node-space/storybook-components/dist/Text'

export const StatusCardState = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const
export type StatusCardStateType = (typeof StatusCardState)[keyof typeof StatusCardState]

export interface StatusCardProps {
  headline: string
  description?: React.ReactNode
  children?: React.ReactNode
  cardButton?: ButtonProps
  extraButton?: ButtonProps
  testid?: string
  borderless?: boolean
  status?: StatusCardStateType
  customIcon?: React.ReactNode
  className?: string
}

export const SheetStatusCard = ({
  headline,
  description,
  children,
  cardButton,
  extraButton,
  testid,
  borderless = false,
  status,
  customIcon,
  className,
}: StatusCardProps) => {
  const hasIcon = !!status || !!customIcon

  const getStateIcon = () => {
    if (status === StatusCardState.ERROR) {
      return <Icon name="CloudLightningIcon" />
    }
    if (status === StatusCardState.SUCCESS) {
      return <Icon name="ClapIcon" color="status-success-500" size="lg" />
    }
    return <></>
  }

  return (
    <CardContainer
      flex
      direction="col"
      className={`p-14 ${className}`}
      gapY={24}
      testid={testid}
      {...(!borderless && { border: 'gray', background: 'white' })}
    >
      {hasIcon && (
        <Box flex centerChildren>
          {customIcon ?? getStateIcon()}
        </Box>
      )}

      <Box flex direction="col" gapY={12}>
        <Text size="lg" weight="medium" color="black" tag="h3" align="center">
          {headline}
        </Text>
        {description && (
          <Box flex>
            <Text size="sm" align="center" color="grey">
              {description}
            </Text>
          </Box>
        )}
        {children}
      </Box>

      <Box flex centerChildren gapX={12}>
        {cardButton && <Button {...cardButton}>{cardButton?.name}</Button>}
        {extraButton && <Button {...extraButton}>{extraButton?.name}</Button>}
      </Box>
    </CardContainer>
  )
}
